export enum EmailProviders {
  Google = 'google',
  // change 'outlook' to 'microsoft' after unifying naming in backend
  Microsoft = 'outlook',
  Mailbox = 'mailbox',
  Recruitee = 'recruitee',
}

export enum ProviderStatuses {
  Connected = 'connected',
  Pending = 'pending',
  Disconnected = 'disconnected',
  Inactive = 'inactive',
}
